import { BaseQueryFn } from '@reduxjs/toolkit/query';
import { AxiosError } from 'axios';

import { apiClient } from '@/api';

export const axiosBaseQuery =
  (): BaseQueryFn =>
  async ({ url, method, data, params }) => {
    try {
      const result = await apiClient({
        url,
        method,
        data,
        params,
      });
      return { data: result.data };
    } catch (axiosError) {
      const err = axiosError as AxiosError;
      return {
        error: {
          status: err.response?.status,
          data: err.response?.data || err.message,
        },
      };
    }
  };
